
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexMDZx9UpPuoUO40oTWdYfMSmZxaVJiv6AU_Au46oVy8EMeta } from "/tmp/tmpvyuryfzc/pages/index.vue?macro=true";
import { default as indexZHT7pBO7VKvimZPH1ELkN2xI2GnS_yjNIo3AnyZDXEMMeta } from "/tmp/tmpvyuryfzc/pages/[area]/index.vue?macro=true";
import { default as indexkc1Yc222n_45Cu27cfKl7SPU0tVXtiFRl4S0iWxu4RH0gMeta } from "/tmp/tmpvyuryfzc/pages/okinawa/index.vue?macro=true";
import { default as indexRUA2zNEXBI1FvMrccQBRpiwjHNt0oCj0GX_Hdo_aHLwMeta } from "/tmp/tmpvyuryfzc/pages/zoom-map/index.vue?macro=true";
import { default as indexmX_UwyrvyGQ3JWOpjgpcVnWhkHnG1_45MS_xEllrFFiAUMeta } from "/tmp/tmpvyuryfzc/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexEBV7PRnHU4Ek1QRkGPoevuo3k015gwDItUKvTO87XpkMeta } from "/tmp/tmpvyuryfzc/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexAUqFgap53rmxW9_ZdfG0Wt2Bfcup8_45bicsX72cI1wg0Meta } from "/tmp/tmpvyuryfzc/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpvyuryfzc/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpvyuryfzc/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpvyuryfzc/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmpvyuryfzc/pages/zoom-map/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpvyuryfzc/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpvyuryfzc/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpvyuryfzc/pages/[area]/[pref]/[id]/index.vue")
  }
]